import { UTM_SESSION_STORAGE_KEY, UtmData, type UtmDataType } from '../../defs';

export function getUtmSessionStorage(): UtmDataType | null {
  const utmValue = sessionStorage.getItem(UTM_SESSION_STORAGE_KEY);
  const utmData: UtmDataType | null =
    utmValue !== null ? UtmData.parse(JSON.parse(utmValue)) : null;
  return utmData;
}
